import { FC } from 'react';
import { useLocationStore } from '../../../stores/locationStore';
import SharedModal from '../Modals/SharedModal';
import { callEvent } from '../../../utils/Amplitude/AmplitudeUtilities';
import { StatusNotification } from '../Notifications/StatusNotification';

interface Props {
  onClose: () => void;
  onCancel: () => void;
  onConfirm: () => void;
  onExited?: () => void;
  show: boolean;
  headerText: string;
  bodyText: string | React.JSX.Element;
  confirmButtonText: string;
  cancelButtonText?: string;
  stackedButtons?: boolean;
  reverseOrder?: boolean;
  formName?: string;
  formID?: string;
  hasError?: boolean;
  isLoading?: boolean;
}

const PreventNavigationModal: FC<Props> = ({
  bodyText,
  cancelButtonText = 'Cancel',
  confirmButtonText,
  formName,
  formID,
  hasError,
  headerText,
  isLoading = false,
  onClose,
  onCancel,
  onConfirm,
  onExited,
  show,
}) => {
  const { activeLocation } = useLocationStore();

  return (
    <SharedModal
      onExited={onExited}
      button={{
        loading: { primary: isLoading },
        onClick: {
          primary: () => {
            onConfirm();
            callEvent('exit form flow', {
              'form name': formName,
              'form id': formID,
              locationNum: activeLocation,
            });
          },
          secondary: onCancel,
        },
        text: { primary: confirmButtonText, secondary: cancelButtonText },
      }}
      error={{
        hasError: hasError,
        message: (
          <StatusNotification
            severity='error'
            boldTextContent='An error occurred. Please try again.'
            hasWrapper={true}
            anchorTop={true}
          />
        ),
      }}
      onClose={onClose}
      show={show}
      suppressClickOutside
      text={{
        body: bodyText,
        header: headerText,
      }}
    />
  );
};

export default PreventNavigationModal;
